import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { CSVLink } from "react-csv";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { LeafCollectionOverviewSchema } from "../leafCollectioOverviewSchema";
import { TableContentLeafCollectionOverviewContent, TableContentWithoutEdit } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';

const screenCode = 'LEAFCOLLECTIONOVERVIEWREPORT'

export function LeafCollectionOverviewReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [tagReadDate, setTagReadDate] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        startDate: "",
        //endDate: "",
    });


    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: "0",
        operationEntityID: "0",
        startDate: "",
        //endDate: "",
    })

    const pdfRef = React.createRef();
    const [errors, setErrors] = useState({});

   const [dayOne, setDayOne] = useState([]);
   const[dayTwo, setDayTwo] = useState([]);
   const[dayThree, setDayThree] = useState([]);
    const schema = Joi.object(LeafCollectionOverviewSchema).options({ allowUnknown: true });
    const contentRowNames = ["collectionPointName","collectionPointID","startTime","endTime", "grossTotal", "tagCount", "supplierCount"]
    const csvHeaders = [
        { label: "Route Name", value: "collectionPointName" },
        { label: "Route ID", value: "collectionPointID" },
        { label: "Tag Read Date", value: "tagReadDate" },
        { label: "Start Time", value: "startTime" },
        { label: "End Time", value: "endTime" },
        { label: "Gross Amount (Kg)", value: "grossTotal" },
        { label: "Tag Count", value: "tagCount" },
        { label: "Supplier Count", value: "supplierCount" }
        
    ];

    const [data, setdata] = useState([]);

    const [data0, setData0] = useState([]);
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);



    
    const [csvData, setCsvData] = useState([]);

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    useEffect(() => {
        createDataTable();
        trackPromise(
            getPermissions()
        );
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

  

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLEAFCOLLECTIONOVERVIEWREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    function destroyDataTable() {
        $('#leafCollectionOverviewReport').DataTable().destroy();
    }

    function createDataTable() {
        $('#leafCollectionOverviewReport').DataTable();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    


    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        //console.log("Date",value);

        //const newValue = value.split('T')[0];
        

        const error = { ...errors };
        const errorMessage = validateProperty(target, LeafCollectionOverviewSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        })
    }

    async function handleSearch(e) {
        e.preventDefault();
      
        let testData0 = [];
        let testData1 = [];
        let testData2 = [];

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchData);
        var result = await service.getLeafCollectionOverview(searchData);



       // console.log(result);

        result.forEach(x => {
            x.tagReadDate = x.tagReadDate.split('T')[0];
            x.startTime = x.startTime.split('T')[1];
            x.endTime = x.endTime.split('T')[1];
        });
        //     if(x.tagReadDate === result[1]){
        //         testData0  = result;
        //     }
        //     else if(x.tagReadDate[1]){
        //         testData1  = result;
        //     }
        //     else if(x.tagReadDate[2]){
        //         testData2  = result;
        //     }

        //  });

         //console.log("Set Data 0",testData0);
         //console.log("Set Data 1",testData1);
         //console.log("Set Data 2",testData2);

        //var merged = _.merge(_.keyBy(testData0, 'collectionPointID'), _.keyBy(testData1, 'collectionPointID'));
       // var values = _.values(merged);

        //console.log("Merged Values:",values);



         
        destroyDataTable();
        setdata(result);
        setIsTableHide(false);
        createDataTable();
        setButtonHide(false);
        setCsvData(result);
    }

    // for (let i = 0; i < 3; i++) {
    //     setTagReadDate([...tagReadDate,
    //         data[i]?.tagReadDate
    //     ])  
    // }
    
        console.log("Tag read date",data[0]?.tagReadDate);
        console.log("Tag read date",data[1]?.tagReadDate);
        console.log("Tag read date",data[2]?.tagReadDate);


    function createFile() {
        var settings = {
            sheetName: 'Leaf Collection Overview Report',
            fileName: 'LeafCollectionOverviewReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            GroupID: groups[searchForm.groupID],
            OperationEntityID: operationEntity[searchForm.operationEntityID],
            StartDate: searchForm.startDate,
            EndDate: searchForm.endDate
        })
    }


    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function hideSearchButton() {

        setSearchButtonHide(true);
    }

    function showSearchButton() {

        setSearchButtonHide(false);
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div ref={pdfRef} className="card-body">
                        <div className="row">
                            <PageHeader
                                title="Leaf Collection Overview Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form >
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        name="groupID"
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        name="operationEntityID"
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <TextField
                                        id="startDate"
                                        label="Search Date *"
                                        name="startDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["startDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["startDate"]}</FormHelperText>}

                                </div>

                                {/* <div className="col-md pb-1">
                                    <TextField
                                        id="endDate"
                                        label="End Date *"
                                        name="endDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                     {errors["endDate"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["endDate"]}</FormHelperText>}
                         
                                </div> */}

                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                </div>
                            </div>
                        </form>

                        {isTableHide ? null :
                            <div>
                              
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive row-top-gap">
                                            <table id="leafCollectionOverviewReport" className="display dataTable no-footer">
                                                <thead>
                                                <tr>
                                                            <th colSpan="2"></th>
                                                            <th colSpan={7} style={{ textAlign: "center" }}>{data[0]?.tagReadDate}</th>
                                                       
                                                </tr>


                                                    <tr>
                                                        <th>Route Name</th>
                                                        <th>Route ID</th>
                                                        <th>Start Time</th>
                                                        <th>End Time</th>
                                                        <th>Gross Amount (Kg)</th>
                                                        <th>Tag Count</th>
                                                        <th>Supplier Count</th>
                                                        
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentWithoutEdit
                                                        data={data}
                                                        contentRowNames={contentRowNames}
                                                        
                                                        
                                                    />
                                                    
                                                </tbody>
                                               
                                            </table>
                                            
                                        </div>
                                        
                                    </div>

                                    
                                    

                                    

                                </div>

                                <div className="pt-2">
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Leaf Collection Overview Report"}
                                        trigger={() => <input
                                            type="submit"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"

                                        />}
                                        content={() => componentRef.current}
                                    />
                                </div>
                                 <div hidden={true}>
                                    <CreatePdf ref={componentRef} data={data}
                                        rowNames={contentRowNames} searchData={selectedSearchValues}
                                        initialData={searchData} groupData={groups} operationEntityData={operationEntity}/>

                                </div> 
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



